export const saveInstitutionCardAdmin = [
  '',
  `mutation saveInstitutionCardAdmin ($input: InputInstitutionCard!, $notes: InputNotes) {
    saveInstitutionCardAdmin (input: $input, notes: $notes)
  }`,
  'saveInstitutionCardAdmin',
];
